import { Component, ViewEncapsulation, Input, HostBinding, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { UNDERSCORE } from '../../../utils/constant';
import { OfferLine } from '../../../../offer/models/offer';
import { PREFIX_OFFER_PRODUCT_ID_EOFFER, PREFIX_OFFER_PRODUCT_ID_CRM } from '../../../../offer/models/offer-utils';
import { formatDimension } from '../../../utils/number.format';
import { createOfferPeriod } from '../../../../offer/components/cards/offer-header-card-block/create-offer-period';
import { safe } from '../../../utils/safe';
import { NumberPipe } from '../../../pipes/number.pipe';

interface DisplayedOfferLine {
	path: string;
	rfqRef: string;
	quantity?: number | undefined;
	steelGrade: string;
	status: string;
	period: string;
	price?: { amount: number; currency?: string | undefined } | undefined;
}

@Component({
	selector: 'copo-result-offer-card',
	templateUrl: './result-card-offer.component.html',
	styleUrl: './result-card-offer.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,

		MatTooltipModule,
		TranslateModule,
		NumberPipe,
	],
})
export class ResultCardOfferComponent implements OnInit {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() offerLine!: OfferLine;
	displayedOfferLine!: DisplayedOfferLine;

	readonly underscore = UNDERSCORE;

	ngOnInit() {
		const ol = this.offerLine;
		if (ol.product) {
			const { header } = ol;
			const { product } = ol;
			this.displayedOfferLine = {
				path:
					`/offer/card/${
						header.id
							? PREFIX_OFFER_PRODUCT_ID_EOFFER
							: PREFIX_OFFER_PRODUCT_ID_CRM
					}${ header.id || safe(header.externalId) }`,
				quantity: product.quantity,
				rfqRef: ol.header.rfqRef || UNDERSCORE,
				steelGrade: product.description.steelGrade || UNDERSCORE,
				status: `eoffer.status.${ product.offerStatus.toLocaleLowerCase() }`,
				period: createOfferPeriod(ol.header),
				price: product.price === undefined ? undefined : { amount: product.price, currency: ol.header.currency }
			};
		}
	}

	getDimension() {
		if (this.offerLine.product?.description.dimension) {
			return formatDimension(
				this.offerLine.product.description.dimension.thickness.value,
				this.offerLine.product.description.dimension.width.value,
				this.offerLine.product.description.dimension.length
					? this.offerLine.product.description.dimension.length.value : undefined
			);
		}
		return UNDERSCORE;
	}
}
